import { products } from '@/shared/config/products';
import { chartOptionsFactory } from '@/shared/ui/chart';

const segmentColors = [
  '#0A77FF',
  '#B5179E',
  '#FD4B28',
  '#FDD021',
  '#14B86F',
  '#7209B7',
  '#F94144',
  '#277DA1',
  '#F9844A',
  '#3A0CA3',
];

/**
 * Calculates the chart options for a donut chart based on provided segments.
 * @param attribute
 * @param backendData
 * @param {string} [centerText] - Optional text to display in the center of the donut chart (e.g., '77%').
 * @returns {object} The chart options object generated by chartOptionsFactory.
 */
export function calculateProductsChartOptions(backendData, attribute, centerText = '') {
  const allEmpty = backendData.every(item => !item.statistics[attribute]);

  const labels = allEmpty ? ['Немає даних'] : backendData.map(item => products.find(product => product.slug === item.name)?.label?.toUpperCase() || 'N/A');
  const values = allEmpty ? [1] : backendData.map(item => item.statistics[attribute]);
  const colors = allEmpty ? ['#F5F5F5'] : segmentColors.slice(0, labels.length);

  const pieTrace = {
    type: 'pie',
    values: values,
    labels: labels,
    hole: 0.7,
    hoverinfo: 'label+percent',
    marker: {
      colors: colors,
      line: {
        color: 'white',
        width: 3
      }
    },
    textinfo: 'none',
    automargin: true,
  };

  const annotations = [];
  if (centerText) {
    annotations.push({
      text: centerText,
      font: {
        size: 40,
        color: '#9FAFC6',
        family: 'Geist, sans-serif',
      },
      showarrow: false,
      x: 0.5,
      y: 0.5,
      xanchor: 'center',
      yanchor: 'middle',
    });
  }

  const overrides = {
    data: [pieTrace],
    layout: {
      margin: {
        l: 20, r: 20, b: 20, t: 20,
      },
      showlegend: true,
      legend: {
        x: 0.5, y: -0.1,
        xanchor: 'center',
        yanchor: 'top',
        orientation: 'h',
        itemwidth: 20,
        font: {
          size: 16,
          color: 'rgba(0, 0, 0, 1)',
        },
        traceorder: 'normal',
      },
      autosize: true,
      annotations: annotations,
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
    },
    config: {
      displayModeBar: false,
    }
  };

  return chartOptionsFactory.createChartOptions(overrides);
}
